import React from "react";
import { Placeholder, Row, Col } from "react-bootstrap";

const PageSkeleton = () => (
  <div className="p-2 page-skeleton">
    <Row className="mb-3 align-items-center justify-content-between">
      <Col xs={3}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
      <Col xs={2}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>

    <Row className="mb-3">
      <Col xs={6}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
      <Col xs={6}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={4}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>

    <Row className="mb-3">
      <Col xs={6}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
      <Col xs={6}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>
    <Row className="mb-5">
      <Col xs={12}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={12} md={6}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
      <Col xs={12} md={6}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={12} md={4}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
      <Col xs={12} md={4}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
      <Col xs={12} md={4}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={8}>
        <Placeholder animation="wave">
          <Placeholder xs={6} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col xs={6}>
        <Placeholder animation="wave">
          <Placeholder xs={12} style={{ height: 35 }} />
        </Placeholder>
      </Col>
    </Row>
  </div>
);

export default PageSkeleton;
